import r from "../managers/braze-instance.js";
import ControlMessage from "./models/control-message.js";
import InAppMessage from "./models/in-app-message.js";
import se from "./in-app-message-manager-factory.js";
import { MUST_BE_IN_APP_MESSAGE_WARNING as sr } from "../common/constants.js";
import { logger as E, EventTypes as m } from "../../shared-lib/index.js";
export function logInAppMessageImpression(o) {
  if (!r.rr()) return !1;
  if (!(o instanceof InAppMessage || o instanceof ControlMessage)) return E.error(sr), !1;
  var s = o instanceof ControlMessage ? m.zo : m.Gi;
  return se.ea().rt(o, s).W;
}